import React from 'react';
import Breadcrumb from '../../../core/layout/Breadcrumb';
import BannerFormContainer from './BannerFormContainer';

const BannerFormScene = (props) => {
  return (
    <>
      <Breadcrumb
        crumbs={[
          ...(props.location.state && props.location.state.from
            ? [{ text: props.location.state.from.text, link: props.location.state.from.pathname }]
            : []),
          {
            text: props.params.bannerId ? 'Edit Banner' : 'Create Banner',
          },
        ]}
      />
      <BannerFormContainer bannerId={props.params.bannerId} />
    </>
  );
};

export default BannerFormScene;
